module.exports = __webpack_public_path__ + "img/injection.01de0614.png";